export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al lote"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modificar lote"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "add_package_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir paquete"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to batch"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit batch"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
          "add_package_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add package"])}
        }
      }
    }
  })
}